'use strict'

import signal from './signal'

/**
 * 启动自己声音设备
 */
function startDeviceAudioIn (netcall) {
  var deviceId
  netcall.getDevicesOfType(WebRTC.DEVICE_TYPE_AUDIO_IN).then(list => {
    deviceId = list[0].deviceId
  })

  netcall
    .startDevice({
      type: WebRTC.DEVICE_TYPE_AUDIO_IN,
      device: { deviceId: deviceId }
    })
    .then(() => {
      console.log('启动麦克风成功')
      // 通知对方自己开启了麦克风
      netcall.control({
        command: WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_AUDIO_ON
      })
    })
    .catch(() => {
      console.log('启动麦克风失败')
    })
}

/**
 * 播放自己的声音设备
 * @param {*} netcall
 */
function startDeviceAudioOutLocal (netcall) {
  netcall
    .startDevice({
      type: WebRTC.DEVICE_TYPE_AUDIO_OUT_LOCAL,
      device: { deviceId: '' }
    })
    .catch(() => {
      console.log('播放自己的声音失败')
    })
}

/**
 * 启动播放对方声音
 * @param {} netcall
 */
function startDeviceAudioOutChat (netcall) {
  netcall
    .startDevice({
      type: WebRTC.DEVICE_TYPE_AUDIO_OUT_CHAT,
      device: { deviceId: '' }
    })
    .catch(() => {
      console.log('播放对方的声音失败')
    })
}

function startDeviceVideo (netcall) {
  return netcall
    .startDevice({
      type: WebRTC.DEVICE_TYPE_VIDEO
    })
    .then(() => {
      // 通知对方自己开启了摄像头
      netcall.control({
        command: WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_ON
      })
    })
    .catch(() => {
      // 通知对方自己的摄像头不可用
      netcall.control({
        command: WebRTC.NETCALL_CONTROL_COMMAND_SELF_CAMERA_INVALID
      })
      console.log('启动摄像头失败')
    })
}

// 实例化 RCT
const webRTC = (nim, mtAccount, type) => {
  var netcall = WebRTC.getInstance({
    nim: nim,
    container: document.getElementById('container'),
    remoteContainer: document.getElementById('remoteContainer'),
    debug: true
  })

  signal.initSignal(netcall, mtAccount, type)

  return netcall
}

const hangup = netcall => {
  netcall.hangup()
   // 取消呼叫倒计时
  signal.clearCallTimer()
  console.log('挂断-------')
}

export default {
  webRTC,
  hangup
}



// WEBPACK FOOTER //
// ./src/im/index.js